import { Component, Inject } from '@angular/core';

import { HttpEventType, HttpHeaderResponse, HttpResponse } from '@angular/common/http';

import { filter } from 'rxjs/operators';
import { interval } from 'rxjs';
import { DocumentService } from 'src/app/services/document.service';
import * as _ from 'lodash';

import { EDocumentType } from './document-type';
import { CoreData } from '../../core-data';
import { db } from '../../../db/db';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-multiple-file-upload-box',
    templateUrl: 'multiple-file-upload-box.html',
    styleUrls: ['./multiple-file-upload-box.scss']
})
export class MultipleFileUploadBoxDialog {
    IsMultiple: boolean = true;
    Files: File[] = [];
    PercentDone = 0;
    Accept: string;
    IsForImport: boolean;
    private Sub;
    Code: string;
    private type: EDocumentType;
    public IsLoading = false;


    WithInputText: boolean;
    InputLabel: string;
    
    public get CanAddDocument() {
        return this.Files.length > 0;
    }

    constructor(
        public coreData: CoreData,
        public datepipe: DatePipe,
        public dialogRef: MatDialogRef<MultipleFileUploadBoxDialog>,
        private documentService: DocumentService,

        @Inject(MAT_DIALOG_DATA) public data) {
        this.Code = data.code; // Taxon Code, Analysis Code, Intervention Code
        this.type = data.type;
        this.IsForImport = data.isForImport;
        this.IsMultiple = data.isMultiple;

        this.WithInputText = data.withInputText
        this.InputLabel = data.label
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onFileChange(event) {

        const files = event.srcElement.files as File[];
        if (files) {
            this.Files.push(...Array.from<File>(files));
        }
        this.Files = _.uniqBy(this.Files, 'name');
    }

    onFileFromDragNDrop(event) {
        let files = event instanceof FileList ? event : event.files;

        for (let index = 0; index < files.length; index++) {
            const element = files[index];
            this.Files.push(element);
        }
        this.Files = _.uniqBy(this.Files, 'name');
    }

    remove(file: File): void {
        const index = this.Files.indexOf(file);

        if (index >= 0) {
            this.Files.splice(index, 1);
        }
    }

    async uploadDocument() {
        this.IsLoading = true;
        if (this.IsForImport) {
            this.importInterventionList();
        } else {
            if (this.coreData.IsMobile) {

                const toBase64 = file => new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });

                const result = await toBase64(this.Files[0]);
                // TODO NEW DB
                // this.pictureDbService.savePicture(this.pictureDbService.generatePictureKey(this.interventionCode, this.type), result).subscribe(x => {
                //     this.coreData.setOfflineInterventionPictureList(this.interventionCode, this.type);
                //     this.dialogRef.close(true);
                // });

                await db.attachPictureToIntervention(
                    await db.getInterventionByCode(this.Code),
                    await db.mapDocumentToPictureEntity(
                        this.type,
                        null,
                        result as string,
                        `${this.datepipe.transform(Date.now(), 'dd-MM-yyyy')}[${this.Code}][DT-${this.type}].jpg`));

            } else if (!this.IsMultiple) {
                this.sendDocument();
            } else if (this.IsMultiple) {
                this.sendIBMRTaxonPhotoList();
            }
        }
    }

    sendDocument() {

        this.documentService.createDocument(this.Code, this.type, this.Files[0])
            .pipe(filter((e: any) => e !== undefined))
            .subscribe(
                event => {
                    if (event.type === HttpEventType.UploadProgress && this.IsLoading) {
                        this.PercentDone = Math.round(80 * event.loaded / event.total);
                        if (this.PercentDone >= 80) {
                            this.Sub = interval(100).pipe().subscribe(() => {
                                if (this.PercentDone < 99) {
                                    this.PercentDone = this.PercentDone + 1;
                                }
                            });
                        }
                    } else if (event instanceof HttpResponse) {
                        this.Sub.unsubscribe();
                        this.PercentDone = 100;
                        setTimeout(() => {
                            this.PercentDone = 0;
                            this.IsLoading = false;
                            this.dialogRef.close(event.body); // EDM ID
                        }, 500);
                    } else if (event instanceof HttpHeaderResponse) { // GROSS PROBLEM
                        if (event.status === 500) {
                            this.dialogRef.close();
                        }
                    }
                },
                (err) => {
                    this.Sub.unsubscribe();
                    this.IsLoading = false;
                    this.dialogRef.close();
                    console.log('Upload Error:', err);
                }, () => {
                }
            );
    }

    sendIBMRTaxonPhotoList() {
        this.documentService.uploadPhoteDesJolisTaxon(this.Code, this.Files)
            .pipe(filter((e: any) => e !== undefined))
            .subscribe(
                event => {
                    if (event.type === HttpEventType.UploadProgress && this.IsLoading) {
                        this.PercentDone = Math.round(80 * event.loaded / event.total);
                        if (this.PercentDone >= 80) {
                            this.Sub = interval(100).pipe().subscribe(() => {
                                if (this.PercentDone < 99) {
                                    this.PercentDone = this.PercentDone + 1;
                                }
                            });
                        }
                    } else if (event instanceof HttpResponse) {
                        this.Sub.unsubscribe();
                        this.PercentDone = 100;
                        setTimeout(() => {
                            this.PercentDone = 0;
                            this.IsLoading = false;
                            this.dialogRef.close(event.body); // EDM ID
                        }, 500);
                    } else if (event instanceof HttpHeaderResponse) { // GROSS PROBLEM
                        if (event.status === 500) {
                            this.dialogRef.close();
                        }
                    }
                },
                (err) => {
                    this.Sub.unsubscribe();
                    this.IsLoading = false;
                    this.dialogRef.close();
                    console.log('Upload Error:', err);
                }, () => {
                }
            );
    }

    importInterventionList() {
        this.documentService.createInterventionList(this.type, this.Files[0])
            .pipe(filter((e: any) => e !== undefined))
            .subscribe(
                event => {
                    if (event.type === HttpEventType.UploadProgress && this.IsLoading) {
                        this.PercentDone = Math.round(80 * event.loaded / event.total);
                        if (this.PercentDone >= 80) {
                            this.Sub = interval(100).pipe().subscribe(() => {
                                if (this.PercentDone < 99) {
                                    this.PercentDone = this.PercentDone + 1;
                                }
                            });
                        }
                    } else if (event instanceof HttpResponse) {
                        this.Sub.unsubscribe();
                        this.PercentDone = 100;
                        setTimeout(() => {
                            this.PercentDone = 0;
                            this.IsLoading = false;
                            this.dialogRef.close(event.body); // EDM ID
                        }, 500);
                    } else if (event instanceof HttpHeaderResponse) { // GROSS PROBLEM
                        if (event.status === 500) {
                            this.dialogRef.close();
                        }
                    }
                },
                (err) => {
                    this.Sub.unsubscribe();
                    this.IsLoading = false;
                    this.dialogRef.close();
                    console.log('Upload Error:', err);
                }, () => {
                }
            );
    }
}
